import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import React from 'react';
import DesktopProfileVideoPrimis from './primis/DesktopProfileVideo';
import DesktopProfileVideoTab from './taboola/DesktopProfileVideo';
const DesktopProfileVideo = ({ safety = 'off', safetyState })=>{
    const isTaboola = useFlag('ads_taboola');
    if (isTaboola) {
        return /*#__PURE__*/ React.createElement(DesktopProfileVideoTab, {
            safety: safety,
            safetyState: safetyState
        });
    }
    return /*#__PURE__*/ React.createElement(DesktopProfileVideoPrimis, {
        safety: safety,
        safetyState: safetyState
    });
};
DesktopProfileVideo.displayName = 'DesktopProfileVideo';
export default DesktopProfileVideo;
